export enum AttendanceContractTypeEnum {
  Null = -1,
  Usual = 0,
  Occasional = 1,
  UsualDis = 2,
}
